import { getApp, getApps, initializeApp } from 'firebase/app'
import config from '../Config'

/* The one Firebase app (project instapres-4c5d8), shared by analytics and
   login: initializing it twice throws. */
export function firebaseApp() {
  return getApps().length ? getApp() : initializeApp(config.FIREBASE)
}
